import { render, staticRenderFns } from "./ConsentBox.vue?vue&type=template&id=ba3bd52a&scoped=true"
import script from "./ConsentBox.vue?vue&type=script&lang=js"
export * from "./ConsentBox.vue?vue&type=script&lang=js"
import style0 from "./ConsentBox.vue?vue&type=style&index=0&id=ba3bd52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3bd52a",
  null
  
)

export default component.exports